import { Button, Icon } from "components/common"
import React from "react"
import { useTranslation } from "react-i18next"
import theme from "utils/themeVars"
import cx from "clsx"

const EditedTaskShowPreviousButton = ({ item, onClick, hideText, showText, doesRowIdExist, compositeId }) => {
  const { t } = useTranslation()

  return (
    <Button
      style={{
        "--btn-color": theme?.["primary-color"],
        "--btn-bg": theme?.["primary-light"],
        "--btn-hover-bg": theme?.["primary-light"],
        marginInlineStart: 6,
        paddingInline: 6,
        height: "auto",
      }}
      className={cx("showBtn p-0 pi-8", !!doesRowIdExist(item?.id) && "showAlways")}
      size="small"
      onClick={onClick}
    >
      <span style={{ display: "inline-flex" }} className="fs12 semiBold">
        {doesRowIdExist( compositeId ? compositeId : item?.id) ? (
          <>
            <span>{hideText}</span>
            <Icon icon="BiChevronsUp" size="1em" />
          </>
        ) : (
          <>
            <span>{showText}</span>
            <Icon icon="BiChevronsDown" size="1em" />
          </>
        )}
      </span>
    </Button>
  )
}

export default EditedTaskShowPreviousButton
